import React, { useState,useEffect,useRef } from 'react';
import './classes/ScoutingRequestsForm.css';
import PhoneInput, {
  formatPhoneNumber,
  formatPhoneNumberIntl,
  isPossiblePhoneNumber,
  isValidPhoneNumber,getCountryCallingCode
} from 'react-phone-number-input'
import { configData } from "../config";
import Select from 'react-dropdown-select';
import { Helmet } from 'react-helmet';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import SalespersonSidebar from "./SalespersonSidebar";


const ScoutingRequestsFrom = () => {
  const initialForm = {
    players_first_name:'',
    players_last_name:'',
    players_age:'',
    sport_played:'',
    currently_playing_for:'',
    position_played:'',
    players_country:'',
    players_state:'',
    players_ranking_website:'',
    players_video_link:'',
    first_name:'',
    last_name:'',
    email:'',
    phone:'',
    street_address:'',
    relationship_with_player:'',
    are_you_an_smww_agent_advisor:'',
    notes:'',
    showStateField: false,
    captcha_response:'',
    pageURL:window.location.href
  };
 
  const [formData, setFormData] = useState(initialForm);
  const [errors, setErrors] = useState([]);
  const[success,setSuccess] = useState('');
  const [fieldErrors, setFieldErrors] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [buttonText, setButtonText] = useState('Submit');
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [showmsg, setShowmsg] = useState('');
  var loggedin_drupaluid = localStorage.getItem('drupal_uid');

  const inputStyle = {
  players_first_name: {
    border: fieldErrors.players_first_name ? '2px solid red' : '1px solid #777'
  },
  players_last_name: {
    border: fieldErrors.players_last_name ? '2px solid red' : '1px solid #777'
  },
  players_age: {
    border: fieldErrors.players_age ? '2px solid red' : '1px solid #777'
  },
  sport_played: {
    border: fieldErrors.sport_played ? '2px solid red' : '1px solid #777'
  },
  currently_playing_for: {
    border: fieldErrors.currently_playing_for ? '2px solid red' : '1px solid #777'
  },
  position_played: {
    border: fieldErrors.position_played ? '2px solid red' : '1px solid #777'
  },
  players_country: {
    border: fieldErrors.players_country ? '2px solid red' : '1px solid #777'
  },
   players_state: {
    border: fieldErrors.players_state  ? '2px solid red' : '1px solid #777'
  },
   first_name: {
    border: fieldErrors.first_name ? '2px solid red' : '1px solid #777'
  },
  last_name: {
    border: fieldErrors.last_name ? '2px solid red' : '1px solid #777'
  },
  email: {
    border: fieldErrors.email ? '2px solid red' : '1px solid #777'
  },
  phone: {
    border: fieldErrors.phone ? '2px solid red' : '1px solid #777'
  },
  street_address: {
    border: fieldErrors.street_address ? '2px solid red' : '1px solid #777'
  },
  relationship_with_player: {
    border: fieldErrors.relationship_with_player ? '2px solid red' : '1px solid #777'
  },
   captcha_response: {
    border: fieldErrors.captcha_response ? '2px solid red' : '1px solid #777'
  }
};

    const [countriesList, setCountriesList] = useState([]);
    const [statelist, setStateList] = useState({});
   const [selectedcountry, setSelectedCountry] = useState([]);
    const [selectedState, setSelectedState] = useState('');
       const [captchaText, setCaptchaText] = useState('');
  const canvasRef = useRef(null);
  const [captchaSid, setCaptchaSid] = useState('');
  const [captchaToken, setCaptchaToken] = useState('');
    const app_url = configData.APP_URL;
        useEffect(() => {
            retrieveCountriesList();
            retrieveStateList();   
            if(loggedin_drupaluid > 0) {
              retrievescoutingrequestformsubmission();
            }
        }, []);

        async function  retrievescoutingrequestformsubmission() {
          if(loggedin_drupaluid > 0) {
              const response = await fetch(
              app_url+'smwwscout/requestscoutformsubmissiondetails?loggedin_drupaluid='+loggedin_drupaluid,
                  {
                      method: "GET",
                      headers: {
                      'Content-Type': 'application/json',
                      },
                  }
              )
              const responsedata = await response.json();
              if(responsedata.data.msg == "Already submitted") {
                setShowmsg(responsedata.data.result);
              }
              if(responsedata.data.msg == "Not submitted") {
                setShowmsg('');
              }
            }
          }

         useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    // Generate dynamic values on load
    const sid = Date.now().toString();
    const token = Math.random().toString(36).substr(2);
    setCaptchaSid(sid);
    setCaptchaToken(token);

    initializeCaptcha(ctx);
  }, []);

  const generateRandomChar = (min, max) =>
    String.fromCharCode(Math.floor(Math.random() * (max - min + 1) + min));

  const generateCaptchaText = () => {
    let captcha = '';
    for (let i = 0; i < 3; i++) {
      captcha += generateRandomChar(65, 90);   // A-Z
      captcha += generateRandomChar(97, 122);  // a-z
      captcha += generateRandomChar(48, 57);   // 0-9
    }
    return captcha.split('').sort(() => Math.random() - 0.5).join('');
  };

  const drawCaptchaOnCanvas = (ctx, captcha) => {
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    const colors = ['#000', '#555'];
    const spacing = 150 / captcha.length;

    for (let i = 0; i < captcha.length; i++) {
      const x = 25;
      ctx.font = '20px Roboto Mono';
      ctx.fillStyle = colors[Math.floor(Math.random() * colors.length)];
      ctx.fillText(
        captcha[i],
        x + i * spacing,
        Math.floor(Math.random() * 16 + 25)
      );
    }
  };

  const initializeCaptcha = (ctx) => {
    setFormData((prev) => ({ ...prev, captcha_response: '' }));
    const newCaptcha = generateCaptchaText();
    setCaptchaText(newCaptcha);
    drawCaptchaOnCanvas(ctx, newCaptcha);
  };

        const handleOpen = () => {
            setSelectedCountry([]);
            setFormData(prevState => ({
            ...prevState,
            players_country:''
            }));

        };
const handleChange = (input) => {
  // Normal input event
  if (input?.target) {
    const { name, value } = input.target;

    // Country-specific logic
    if (name === 'players_country') {
      if (value === 'US' || value === 'CA') {
        setFormData((prev) => ({
          ...prev,
          [name]: value,
          showStateField: true,
          players_state:'',
        }));
      } else {
        setFormData((prev) => ({
          ...prev,
          [name]: value,
          showStateField: false,
          players_state:'',
        }));
      }
    } else {
      // Normal field update
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  } else {
    // Handle custom input (like react-dropdown-select) if needed
    console.error("handleChange called incorrectly:", input);
  }
};


  async function retrieveStateList() {
    const statelistresponse = await fetch(
      app_url+'smwwstates/getstatelist',
      {
        method: "GET",

        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const statelistdata = await statelistresponse.json();
    
    const statelist = {};
    Object.keys(statelistdata.data.result).forEach(function(key) {
      
      statelist[key] = statelistdata.data.result[key];
    
    });
    setStateList(statelist);
   
  }
  async function retrieveCountriesList() {
    const countrieslistresponse = await fetch(
      app_url+'smwwcountries/getcountrieslist',
      {
        method: "GET",

        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const countrieslistdata = await countrieslistresponse.json();

    setCountriesList(countrieslistdata.data.result);   
    
  }
  useEffect(() => {
          Promise.all([
              
              
          ])
          .then(() => {
       
          setIsLoading(false);
          })
       
      },[]);
      
const validateForm = () => {
  const newFieldErrors = {};
  const newMessages = [];

  if (!formData.players_first_name) {
    newFieldErrors.players_first_name = true;
    newMessages.push("Player's First Name field is required.");
  }
  if (!formData.players_last_name) {
    newFieldErrors.players_last_name = true;
    newMessages.push("Player's Last Name field is required.");
  }
  if (!formData.players_age) {
    newFieldErrors.players_age = true;
    newMessages.push("Player's Age field is required.");
  }
  if (formData.players_age) {
if (!/^\d+$/.test(formData.players_age)) {
   newFieldErrors.players_age = true;
   newMessages.push("Player's Age must contain numbers only.");   
  }
}
  if (!formData.sport_played) {
    newFieldErrors.sport_played = true;
    newMessages.push("Player's Sport field is required.");
  }
  if (!formData.currently_playing_for) {
    newFieldErrors.currently_playing_for = true;
    newMessages.push("Team Which the Player is On field is required.");
  }
  if (!formData.position_played) {
    newFieldErrors.position_played = true;
    newMessages.push("Player's Position field is required.");
  }
  if (!formData.players_country) {
    newFieldErrors.players_country = true;
    newMessages.push("Where to Scout the Player field is required.");
  }
  if (formData.players_country == "US") {
  if (!formData.players_state) {
    newFieldErrors.players_state = true;
    newMessages.push("Player State is required.");
  }
}
  if (!formData.first_name) {
    newFieldErrors.first_name = true;
    newMessages.push("Your First Name field is required.");
  }
  if (!formData.last_name) {
    newFieldErrors.last_name = true;
    newMessages.push("Your Last Name field is required.");
  }

if (!formData.email) {
  newFieldErrors.email = true;
  newMessages.push("Your Email Address field is required.");
} else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {
  newFieldErrors.email = true;
  newMessages.push("Invalid Email Format.");
}

// REQUIRED CHECK (fix for your issue)
if (!formData.phone || formData.phone.trim() === "") {
  newFieldErrors.phone = true;
  newMessages.push("Your Phone Number field is required.");
}

 // Phone validation block (your logic, fixed)

if (formData.phone && formData.phone.trim()) {
  const digitsOnly = formData.phone.replace(/\D/g, '');

  try {
    let codeLength = 0;

    if (formData.phoneCountry) {
      codeLength = getCountryCallingCode(formData.phoneCountry).length;
    } else {
      const match = digitsOnly.match(/^\d{1,3}/);
      if (match) codeLength = match[0].length;
    }

    if (digitsOnly.length > codeLength) {
      // Full number entered → must validate
      if (!isValidPhoneNumber(formData.phone)) {
        newFieldErrors.phone = true;
        newMessages.push('Invalid Primary Phone Number');
      }
    } else {
      // Only country code → treat as empty (NO state mutation!)
      newFieldErrors.phone = true;
      newMessages.push('Your Phone Number field is required.');
    }

  } catch (err) {
    if (!isValidPhoneNumber(formData.phone)) {
      newFieldErrors.phone = true;
      newMessages.push('Invalid Primary Phone Number');
    }
  }
}


  if (!formData.street_address) {
    newFieldErrors.street_address = true;
    newMessages.push("Your Location field is required.");
  }

  if (!formData.relationship_with_player) {
    newFieldErrors.relationship_with_player = true;
    newMessages.push("Relationship to the Player field is required.");
  }

  if (formData.are_you_an_smww_agent_advisor === "") {
    newFieldErrors.are_you_an_smww_agent_advisor = true;
    newMessages.push("Please select whether you are an SMWW Agent Advisor.");
  }

    // CAPTCHA Validation
if (!formData.captcha_response) {
  newFieldErrors.captcha_response = true;
  newMessages.push('What code is in the image? field is required.');
} else if (formData.captcha_response.trim() !== captchaText.trim()) {
  newFieldErrors.captcha_response = true;
  newMessages.push('The CAPTCHA code entered is incorrect.');
}
  setFieldErrors(newFieldErrors);
  setErrors(newMessages);

  return newMessages.length === 0;
};


 const handleSubmit = async (e) => {
  e.preventDefault();
  if (!validateForm()) {
      setSuccess('');
      window.scrollTo(0, 0);
      return;
    }
    setButtonText('Submitting...');
    setIsButtonDisabled(true);
    const response = await fetch(app_url+'smwwdrupal/addscoutingrequest', {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: {
        'Content-Type': 'application/json',
      },
      });
      const data = await response.json();
       if(data.data.result === "user_created") {
         setSuccess("Form submitted successfully!");
          setSelectedCountry([]);
          setErrors([]);
          setFormData(initialForm);
          setButtonText('Submit');
          setIsButtonDisabled(false);
          window.scrollTo(0, 0);
       }
       else if(data.data.result === "error") {
        
        window.scrollTo(0, 0);
       }
};
// const handleSubmit = (e) => {
//   e.preventDefault();

//   if (validateForm()) {
//     setSuccess("Form submitted successfully!");
//     setErrors([]);
//     setFormData(initialForm);

//     window.scrollTo(0, 0);
//   }else{
//     window.scrollTo(0, 0);
//   }
//   console.log("submitted formdata:",formData);
// };


  return (
     <div id="main" className='scouting-request-form-main'>  
      <Helmet><title>Request a Sports Scouting Reports | SMWW Scout</title></Helmet>    
        <div className="left"></div>
		
         <div className="center left-center">
             <div className='scouting-request-form-container'>
            {errors.length > 0 && (
          <div className="set-message-error" style={{ background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat`}}>
           {errors.map((item, index) => {
           return <>{item}<br /></>
          
        })}  
          </div>
        )}
        {success && (
          <div className="set-message-done">
            <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span><span dangerouslySetInnerHTML={{__html: success}}></span>
          </div>       
        )}
        {showmsg && (
          <div className="set-message-done">
            <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span><span dangerouslySetInnerHTML={{__html: showmsg}}></span>
          </div>
        )}
                <h1>Request a Free Scouting Report on a Athlete</h1>
                <p>Through our extensive list of Scouts worldwide, we might be able to provide you with scouting reports that already exist, create a current scouting report, or lead you to scouts who can fulfill your request. Please fill out the following form and a Scout or scouts in your region will contact you. Complete information about your scouting request will increase the likelihood of a scout contacting you. All reports are complimentary. These scouts are looking for exposure to the industry and practicing their new skills.</p>
                <p>Fill out our Scouting Report Request form here. Upon doing so, your request will go to a display board for scouts all over the world and they can contact you.</p>
                <p>* Denotes a required field.</p>
                <form onSubmit={handleSubmit}>
                      <fieldset className="form-wrapper" id="edit-player-info-group" style={{"border":0,"padding":0}}>
                        <legend><span className="fieldset-legend">Part 1: Player Information</span></legend>                        
                          <div className="fieldset-wrapper">
                            <div className="form-item">
                                <label htmlFor="edit-players-first-name">Player's First Name <span className="form-required" title="This field is required.">*</span></label>
                                <input 
                                    type="text" 
                                    id="edit-players-first-name" 
                                    name="players_first_name" 
                                    value={formData.players_first_name} 
                                    size="30" 
                                    maxLength="128" 
                                    className={fieldErrors.players_first_name ? 'input-error' : ''}
                                    style={inputStyle.players_first_name}
                                    onChange={handleChange}
                                />
                            </div>
                          <div className="form-item">
                              <label htmlFor="edit-players-last-name">Player's Last Name <span className="form-required" title="This field is required.">*</span></label>
                              <input type="text" 
                                id="edit-players-last-name" 
                                name="players_last_name" 
                                value={formData.players_last_name} 
                                size="30" 
                                maxLength="128" 
                                className={fieldErrors.players_last_name ? 'input-error' : ''}
                                style={inputStyle.players_last_name}
                                onChange={handleChange}
                              />
                        </div>
                        <div className="form-item">
                            <label htmlFor="edit-players-age">Player's Age <span className="form-required" title="This field is required.">*</span></label>
                            <input 
                                type="text" 
                                id="edit-players-age" 
                                name="players_age" 
                                value={formData.players_age} 
                                size="30" 
                                maxLength="128" 
                                className={fieldErrors.players_age ? 'input-error' : ''}
                                style={inputStyle.players_age}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-item">
                             <label htmlFor="edit-sport-played">Player's Sport <span className="form-required" title="This field is required.">*</span></label>
                             <select 
                               id="edit-sport-played" 
                               name="sport_played" 
                               value={formData.sport_played}
                               className={fieldErrors.sport_played ? 'input-error' : ''}
                               style={inputStyle.sport_played}
                               onChange={handleChange}
                               >
                                <option value="" selected="selected">-Select-</option>
                                <option value="2">Baseball</option>
                                <option value="3">Basketball</option>
                                <option value="8">Cricket</option>
                                <option value="1">Football (American)</option>
                                <option value="6">Hockey</option>
                                <option value="46">Rugby</option>
                                <option value="4">Soccer</option>
                            </select>
                        </div>
                        <div className="form-itemr">
                            <label htmlFor="edit-currently-playing-for">Team Which the Player is On <span className="form-required" title="This field is required.">*</span></label><div className="description">If the player is a free agent, please write "Free Agent".</div>
                            <input 
                                type="text" 
                                id="edit-currently-playing-for" 
                                name="currently_playing_for" 
                                value={formData.currently_playing_for} 
                                size="30" 
                                maxLength="128" 
                                className={fieldErrors.currently_playing_for ? 'input-error' : ''}
                                style={inputStyle.currently_playing_for}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-item">
                            <label htmlFor="edit-position-played">Player's Position <span className="form-required" title="This field is required.">*</span></label>
                            <input 
                                type="text" 
                                id="edit-position-played" 
                                name="position_played" 
                                value={formData.position_played}
                                size="30" 
                                maxLength="128" 
                                className={fieldErrors.position_played ? 'input-error' : ''}
                                style={inputStyle.position_played}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-item">
                        <label htmlFor="edit-players-country">Where to Scout the Player <span className="form-required" title="This field is required.">*</span></label>
                              <Select                                 
                                id="country" 
                                name="players_country" 
                                searchable={true}                                
                                clearable={true} 
                                clearOnBlur={true} 
                                clearOnSelect={true}
                                backspaceDelete={true}  
                                className={`select-country ${fieldErrors.players_country ? 'input-error' : ''}`}                               
                                style={{
                                    backgroundColor: '#ffffff',
                                    width: '87.8%',
                                    borderRadius: 5,
                                    ...inputStyle.players_country
                                }}                                                  
                                options={countriesList}                                 
                                onChange={(val) => {
                                if(val.length == 0) {
                                    console.log(val);
                                }
                                else{
                                    setSelectedCountry(val);
                                handleChange(
                                    { target: { value: val[0]['value'], name: 'players_country' } }
                                )
                                
                                }}
                                }
                                onDropdownOpen={handleOpen}
                                values={selectedcountry}                                 
                                />
                        </div>
                        {formData.showStateField &&
                        <div className="form-item">
                              <label htmlFor="edit-players-state">State </label>
                                 <select  id="state" name="players_state" value={formData.players_state}  onChange={handleChange}
                                    className={`smww-appn state-field ${fieldErrors.players_state ? 'input-error' : ''}`}
                                    style={inputStyle.players_state}
                                 >
                                    <option value="">Select State</option>
                                    {Object.keys(statelist).map(players_state => {
                                    return <option key={statelist[players_state].name} value={statelist[players_state].name}>{statelist[players_state].name}</option>
                                    })}
                                </select>
                        </div>
                        }
                        <div className="form-item">
                             <label htmlFor="edit-players-ranking-website">Link to a Website(s) That Shows the Player's Ranking </label>
                             <input
                                type="text" 
                                id="edit-players-ranking-website" 
                                name="players_ranking_website" 
                                value={formData.players_ranking_website} 
                                size="30" 
                                maxLength="600" 
                                className="form-text"
                                onChange={handleChange}
                              />
                        </div>
                        <div className="form-item">
                             <label htmlFor="edit-players-video-link">Links to Any Highlight Videos </label>
                             <input 
                                type="text" 
                                id="edit-players-video-link" 
                                name="players_video_link" 
                                value={formData.players_video_link} 
                                size="30" 
                                maxlength="600" 
                                className="form-text"
                                onChange={handleChange}
                             />
                        </div>
                        </div>
                    </fieldset>   

                    <fieldset className="form-wrapper" id="edit-requester-info-group" style={{"border":0,"padding":0}}>
                        <legend><span className="fieldset-legend">Part 2: Requester's Information</span></legend>
                        <div className="fieldset-wrapper">
                            <div className="form-item">
                               <label htmlFor="edit-first-name">Your First Name <span className="form-required" title="This field is required.">*</span></label>
                               <input 
                                    type="text" 
                                    id="edit-first-name" 
                                    name="first_name" 
                                    value={formData.first_name} 
                                    size="30" 
                                    maxLength="128" 
                                    className={fieldErrors.first_name ? 'input-error' : ''}
                                    style={inputStyle.first_name}
                                    onChange={handleChange}
                                    />
                        </div>
                        <div className="form-item">
                            <label htmlFor="edit-last-name">Your Last Name <span className="form-required" title="This field is required.">*</span></label>
                            <input 
                            type="text" 
                            id="edit-last-name" 
                            name="last_name"
                            value={formData.last_name} 
                            size="30" 
                            maxLength="128"
                            className={fieldErrors.last_name ? 'input-error' : ''}
                            style={inputStyle.last_name}
                            onChange={handleChange}
                              />
                        </div>
                        <div className="form-item">
                        <label htmlFor="edit-email">Your Email Address <span className="form-required" title="This field is required.">*</span></label>
                        <input 
                            type="text" 
                            id="edit-email" 
                            name="email" 
                            value={formData.email} 
                            size="30" 
                            maxLength="128" 
                            className={fieldErrors.email ? 'input-error' : ''}
                            style={inputStyle.email}
                            onChange={handleChange}
                        />
                        </div>
                        <div className="form-item phone-input">
                        <label htmlFor="edit-phone">Your Phone Number <span className="form-required" title="This field is required.">*</span></label>
                              <PhoneInput
                                    international
                                    countryCallingCodeEditable={false}
                                    placeholder="Enter phone number"
                                    className={`smww-appn ${fieldErrors.phone ? 'input-error' : ''}`} 
                                    style={inputStyle.phone}
                                    value={formData.phone}
                                    defaultCountry={formData.phoneCountry || 'US'}
                                    onCountryChange={(country) => {
                                      setFormData((prev) => ({
                                        ...prev,
                                        phoneCountry: country,
                                      }));
                                    }}
                                  onChange={(phone) => {

                                    if (!phone) {
                                      console.log('Phone input cleared.');
                                      setFormData((prev) => ({
                                        ...prev,
                                        phone: '',
                                      }));
                                      return;
                                    }

                                    const digitsOnly = phone.replace(/\D/g, '');

                                    let codeLength = 0;

                                    if (formData.phoneCountry) {
                                      codeLength = getCountryCallingCode(formData.phoneCountry).length;
                                    } else {
                                      const match = digitsOnly.match(/^\d{1,3}/);
                                      if (match) {
                                        codeLength = match[0].length;
                                      }
                                    }

                                    if (digitsOnly.length <= codeLength) {
                                      setFormData((prev) => ({
                                        ...prev,
                                        phone: '',
                                      }));
                                    } else {
                                      setFormData((prev) => ({
                                        ...prev,
                                        phone: phone,
                                      }));
                                    }
                                  }}

                                  />
                        </div>
                        <div className="form-item">
                        <label htmlFor="edit-street-address">Your Location <span className="form-required" title="This field is required.">*</span></label>
                        <input 
                              type="text" 
                              id="edit-street-address" 
                              name="street_address" 
                              value={formData.street_address} 
                              size="30" 
                              maxLength="128"
                              className={fieldErrors.street_address ? 'input-error' : ''}
                              style={inputStyle.street_address}
                              onChange={handleChange}
                         />
                        </div>
                        <div className="form-item">
                        <label htmlFor="edit-relationship-with-player">Relationship to the Player <span className="form-required" title="This field is required.">*</span></label>
                              <select 
                                id="edit-relationship-with-player" 
                                name="relationship_with_player"
                                value={formData.relationship_with_player}
                                className={fieldErrors.relationship_with_player ? 'input-error' : ''}
                                style={inputStyle.relationship_with_player}
                                onChange={handleChange}
                              >
                                  <option value="">-Select-</option>
                                  <option value="SMWW Agent Advisor">SMWW Agent Advisor</option>
                                  <option value="Parent">Parent</option>
                                  <option value="Self">Self</option>
                                  <option value="Team Executive">Team Executive</option>
                              </select>
                        </div>
                        <div className="form-item">
                        <label for="edit-are-you-an-smww-agent-advisor">Are You an SMWW Agent Advisor? <span className="form-required" title="This field is required.">*</span></label>
                        <div id="edit-are-you-an-smww-agent-advisor" className="form-radios">
                          <div className="form-item form-type-radio">
                             <input 
                                type="radio" 
                                id="edit-are-you-an-smww-agent-advisor-yes" 
                                name="are_you_an_smww_agent_advisor" 
                                value="Yes"
                                checked={formData.are_you_an_smww_agent_advisor === "Yes"}
                                onChange={handleChange}
                             /> 
                              <label  className="option" htmlFor="edit-are-you-an-smww-agent-advisor-yes">Yes </label>
                        </div>
                        <div className="form-item form-type-radio">
                          <input
                              type="radio"
                              id="edit-are-you-an-smww-agent-advisor-no" 
                              name="are_you_an_smww_agent_advisor" 
                              value="No"
                              checked={formData.are_you_an_smww_agent_advisor === "No"}
                              onChange={handleChange}
                            />  
                          <label className="option" htmlFor="edit-are-you-an-smww-agent-advisor-no">No </label>
                        </div>
                        </div>
                        </div>
                        <div className="form-item">
                           <label htmlFor="edit-notes">Any Other Notes? </label>
                           <input 
                           type="text" 
                           id="edit-notes" 
                           name="notes" 
                           value={formData.notes}
                           size="30" 
                           maxLength="128"
                           onChange={handleChange}
                            />
                        </div>
                         <div className="form-item scout-form-captcha">
                           <div className="scout-captcha">
                                {/* Hidden fields to simulate original behavior */}
                               <input type="hidden" name="captcha_sid" value={captchaSid} />
                              <input type="hidden" name="captcha_token" value={captchaToken} />

                                <canvas
                                  ref={canvasRef}
                                  width="180"
                                  height="60"
                                  title="Image CAPTCHA"
                                  style={{ display: 'block', border: '1px solid white', marginBottom: '10px',backgroundColor:'white' }}
                                ></canvas>

                                <div className="scout-form-item">
                                  <label htmlFor="edit-captcha-response">
                                    What code is in the image? <span className="form-required">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    id="edit-captcha-response"
                                    name="captcha_response"
                                    value={formData.captcha_response}
                                    onChange={(e) =>
                                      setFormData({ ...formData, captcha_response: e.target.value })
                                    }
                                    size="15"
                                    maxLength="128"
                                    className={`${fieldErrors.captcha_response ? 'input-error' : ''}`}
                                    autoComplete="off"
                                    style={inputStyle.captcha_response}

                                  />
                                  <div className="adduser-description1">Enter the characters shown in the image.</div>
                                </div>
                              </div>
                         </div>
                        </div>
                        </fieldset>
                         <div className="adduser-form-actions">
                          <input type="submit" id="edit-submit" className="form-submit" value={buttonText}  disabled={isButtonDisabled} />
                        </div>
                       
                 </form>  
      
      </div> 
      </div>
        <div className="right">

          {/* {
              (userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) ||
              userLoggedInRoles.includes(configData.ROLE_SAADMIN) ||
              userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE))
                  &&  */}
                  <SalespersonSidebar /> 
              {/* }  */}
  </div> 
  <div className='clear'></div>
    
    
  </div>
  );
};

export default ScoutingRequestsFrom;
